import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getDeliveryFee } from '../../services/orderAPI';

// Async thunk for fetching backend delivery fee
export const fetchBackendDeliveryFee = createAsyncThunk(
  'backendDeliveryFee/fetchBackendDeliveryFee',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDeliveryFee();
      return response?.data || null;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch delivery fee'
      );
    }
  }
);

const initialState = {
  amount: 0,
  updatedAt: null,
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const backendDeliveryFeeSlice = createSlice({
  name: 'backendDeliveryFee',
  initialState,
  reducers: {
    clearBackendDeliveryFee: (state) => {
      state.amount = 0;
      state.updatedAt = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBackendDeliveryFee.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchBackendDeliveryFee.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.amount = action.payload?.amount || 0;
        state.updatedAt = action.payload?.updatedAt || null;
      })
      .addCase(fetchBackendDeliveryFee.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
        // Keep amount as 0 if fetch fails
        state.amount = 0;
      });
  },
});

export const { clearBackendDeliveryFee } = backendDeliveryFeeSlice.actions;

export default backendDeliveryFeeSlice.reducer;

// Selectors
export const selectBackendDeliveryFeeAmount = (state) =>
  state.backendDeliveryFee.amount || 0;
export const selectBackendDeliveryFeeStatus = (state) =>
  state.backendDeliveryFee.status;
export const selectBackendDeliveryFeeError = (state) =>
  state.backendDeliveryFee.error;
export const selectBackendDeliveryFeeUpdatedAt = (state) =>
  state.backendDeliveryFee.updatedAt;
